const deskTop = () => import('@/views/main/desktop/desktop.vue')
export default {
  path: '/main/desktop/desktop',
  name: 'deskTop',
  component: deskTop,
  children: []
}
